// @ts-check

/**
 * @param {string} text
 *
 * @return {HTMLElement|null}
 */
export function textToHTML( text ) {
    const container = document.createElement( 'div' );
    container.innerHTML = text;
    //@ts-ignore Realistically only going to be htmlelement
    return container.firstElementChild;
}